import React from 'react'
import Tooltip from 'react-tooltip'
import cx from 'classnames'

import Input from 'components/form/Input/Input'
import DatePicker from 'components/form/DatePicker/DatePicker'

import s from './Input.scss'

import helpImage from './images/help.svg'


const _Input = (props) => {
  const {
    className, valueLink, inputWrapperClassName, placeholder, type, min, max, label, help, from1900, calendarOptions, mask, name,
    autoComplete, id, disabled, withRequiredStar, onMouseEnter, onMouseLeave,
  } = props

  return (
    <div className={className} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <div className={s.wrapper}>
        {
          Boolean(help) && (
            <Tooltip className={s.tooltip} id={`tip${label}`} effect="solid" place="top">
              <div dangerouslySetInnerHTML={{ __html: help }}/>
            </Tooltip>
          )
        }
        <div className={s.label}>
          {label}
          {
            Boolean(help) && (
              <img
                className={s.help}
                src={helpImage}
                data-tip
                data-for={`tip${label}`}
              />
            )
          }
        </div>
        <div className={cx(s.inputWrapper, inputWrapperClassName, { [s.error]: Boolean(valueLink.error) })}>
          {
            Boolean(type === 'date') ? (
              <DatePicker
                placeholderClassName={s.placeholder}
                locale="ru"
                valueLink={valueLink}
                placeholder={placeholder}
                from1900={from1900}
                calendarOptions={calendarOptions}
              />
            ) : (
              <Input
                placeholderClassName={s.placeholder}
                id={id}
                valueLink={valueLink}
                type={type}
                min={min}
                max={max}
                placeholder={placeholder}
                mask={mask}
                name={name}
                autoComplete={autoComplete}
                disabled={disabled}
                withRequiredStar={withRequiredStar}
              />
            )
          }
        </div>
      </div>
    </div>
  )
}


export default _Input